import { getStudentAssignmentDetailsApi } from "@/api/reportingApi";
import {
    AssignmentInterface,
    MarkedAssignmentInterface
} from "@/ts/interfaces/MarkingPortal/AssignmentInterface";
import { mapStudentAssignmentWithDetailsApiData } from "@/utils/markingPortalDataMapper";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getStudentAssignmentDetailsThunk = createAsyncThunk<
    {
        data: AssignmentInterface;
        markOfRecordSubmission: MarkedAssignmentInterface | null;
    },
    { studentId: number; assignmentUUID: string },
    { rejectValue: string }
>(
    "reporting/assignmentDetails/fetch",
    async ({ studentId, assignmentUUID }, { rejectWithValue }) => {
        try {
            const response = await getStudentAssignmentDetailsApi(
                studentId,
                assignmentUUID
            );
            const d = response?.data?.data;

            const singleAssignment: AssignmentInterface =
                mapStudentAssignmentWithDetailsApiData(
                    d?.assignment,
                    d?.assignmentAssets,
                    d?.assignmentResources,
                    d?.assignmentDeliverables,
                    d?.allSubmissions,
                    false,
                    d?.exemptions,
                    true,
                    "reporting"
                );

            // Portal flags the mark of record once — highest mark,
            // most-recent tie-break (ASG-MARK-8 / ASG-MARK-20). The browser
            // reads the flag; it never compares percentages (REP-ASG-9).
            // No flagged submission is a valid payload and must not collapse
            // the page (REP-ASG-8).
            const markOfRecordSubmission =
                singleAssignment?.assignmentDetail?.markedSubmissions?.find(
                    (submission: MarkedAssignmentInterface) =>
                        submission?.isMarkOfRecord === true
                ) ?? null;

            return { data: singleAssignment, markOfRecordSubmission };
        } catch (err: unknown) {
            const error = err as {
                response?: { data?: { message?: string } };
                message?: string;
            };

            return rejectWithValue(
                error?.response?.data?.message ??
                    error?.message ??
                    "Failed to load assignment details"
            );
        }
    }
);
